module.exports = __webpack_public_path__ + "fonts/iconfont.0b5d3bc.ttf";